import React from "react";
import './Header.css'; // Import CSS file

export default function Header() {
  return (
    <header className="header">
      <div className="logo">akinwuntan ayomide.dev</div>
      <nav className="nav-links">
        <a href="#about">About</a>
        <a href="#skills">Skills</a>
        <a href="#projects">Projects</a>
        <a href="#contact">Contact</a>
      </nav>
    </header>
  );
}
